// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"Bonus_contentContainer__3u7dd","translation":"Bonus_translation__2vpEN","checkboxContainer":"Bonus_checkboxContainer__81V5I"};